import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, useHistory } from "react-router-dom"
import { Col, Container, Row, Table, Button } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCurrentUser } from "actions/auth"
import PropTypes from "prop-types"
import { connect } from "react-redux"
const PaymentDashboard = ({ getCurrentUser }) => {
  const history = useHistory()
  const [paymentData, setPaymentData] = useState(null)
  const [overallData, setOverallData] = useState(null)

  const [paymentMethod, setPaymentMethod] = useState("")
  const [amount, setAmount] = useState("")
  const [comment, setComment] = useState("")

  const [instructor, setInstructor] = useState(null)
  const handleSubmit = async e => {
    e.preventDefault()

    // Validate inputs
    if (!paymentMethod || !amount) {
      alert("Please select a payment method and enter an amount")
      return
    }

    const numericAmount = parseInt(amount)
    if (isNaN(numericAmount) || numericAmount <= 0) {
      alert("Amount must be a number greater than 0")
      return
    }

    if (
      numericAmount >
      instructor?.balance -
        instructor?.withdrawal -
        instructor?.pendingWithdrawal
    ) {
      alert("Amount exceeds available balance for withdrawal")
      return
    }

    // Prepare data
    const date = new Date()
    const applyDate = date.toLocaleDateString("en-GB")

    const paymentData = {
      paymentMethod,
      amount: numericAmount,
      comment,
      applyDate,
    }

    try {
      // Make API request
      const response = await fetch(
        `${process.env.REACT_APP_URL}/new/api/instructor/payment/apply/withdrawal/${authUser?._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Add authorization header if needed
            // 'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(paymentData),
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.message || "Failed to process withdrawal")
      }

      const result = await response.json()

      // Handle success
      console.log("Withdrawal successful:", result)
      // alert("Withdrawal request submitted successfully!")

      //agian fetch the payment data
      getPaymentData()

      // Reset form
      setPaymentMethod("")
      setAmount("")
      setComment("")

      // Optionally refresh data or redirect
      // fetchWithdrawalHistory(); // if you have this function
    } catch (error) {
      console.error("Error submitting withdrawal:", error)
      toastr.error(`Error: ${error.message}`)
    }
  }

  const isFormValid = paymentMethod && amount

  const stringifyUser = localStorage.getItem("authUser")
  const authUser = stringifyUser !== null ? JSON.parse(stringifyUser) : null

  const getPaymentData = () => {
    fetch(
      `${process.env.REACT_APP_URL}/new/api/instructor/payment/all/withdrawal/${authUser?._id}`,
      // "https://api-test.qlearn.com.bd/new/api/instructor/payment/all/withdrawal/628eee8f5356a103b5f87d09",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    )
      .then(res => res.json())
      .then(data => {
        console.log(data, "paymentData")
        if (data?.success) {
          setPaymentData(data?.data?.withdrawalHistory || [])
          setOverallData(data?.data?.overallBalances || null)
          setInstructor(data?.data?.instructor || null)
        }
        // setPaymentData(data?.data?.course)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getPaymentData()
  }, [authUser?._id])
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Qlearn</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Payment" breadcrumbItem="Dashboard" />

          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="rounded bg-white p-3">
                <p className="fs-6 fw-bold">Total Balance</p>
                <p className="fs-2 fw-bold">
                  ৳ {overallData?.totalBalance || 0}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="rounded bg-white p-3">
                <p className="fs-6 fw-bold">Withdrawal Balance</p>
                <p className="fs-2 fw-bold">
                  ৳ {overallData?.paidBalance || 0}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="rounded bg-white p-3">
                <p className="fs-6 fw-bold">Available for Withdrawal</p>
                <p className="fs-2 fw-bold">
                  ৳ {overallData?.availableBalance || 0}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="rounded bg-white p-3">
                <p className="fs-6 fw-bold">Withdraw Pending</p>
                <p className="fs-2 fw-bold">
                  ৳ {overallData?.pendingBalance || 0}
                </p>
              </div>
            </div>
          </div>

          <div className="row p-3 mt-4 ">
            <div
              style={{
                position: "relative",
              }}
              className=" border border-black rounded"
            >
              <div
                style={{
                  position: "absolute",
                  top: "-18px",
                  backgroundColor: "white",
                  padding: "5px 20px",
                }}
                className="fs-6 fw-bold"
              >
                Withdrawal Request
              </div>
              <div className="withdraw-request p-3">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3 align-items-center mb-3">
                    <div className="col-md-3 col-12">
                      <select
                        className="form-control"
                        value={paymentMethod}
                        onChange={e => setPaymentMethod(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select Payment Method...
                        </option>
                        <option value="Bkash">Bkash</option>
                        <option value="Cash">Cash</option>
                        <option value="Check">Cheque</option>
                      </select>
                    </div>

                    <div className="col-md-3 col-12">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Amount..."
                        value={amount}
                        min={0}
                        onChange={e => setAmount(e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-md-4 col-12">
                      <textarea
                        className="form-control"
                        placeholder="Add comment..."
                        rows="1"
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                      />
                    </div>

                    <div className="col-md-2 col-12">
                      <button
                        className="btn btn-primary w-100 send-btn"
                        disabled={
                          !isFormValid ||
                          amount <= 0 ||
                          amount >
                            instructor?.balance -
                              instructor?.withdrawal -
                              instructor?.pendingWithdrawal
                        }
                        type="submit"
                      >
                        SEND
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="row p-3 mt-4">
            <div
              style={{
                position: "relative",
              }}
              className=" border border-black rounded"
            >
              <div
                style={{
                  position: "absolute",
                  top: "-18px",
                  backgroundColor: "white",
                  padding: "5px 20px",
                }}
                className="fs-6 fw-bold"
              >
                Payment History
              </div>

              <table className="table mt-4">
                <thead>
                  <tr>
                    <th data-label="Apply date" scope="col">
                      Apply Date
                    </th>
                    <th scope="col">Receive Date</th>
                    <th scope="col">Payment Method</th>
                    <th scope="col">Received Amount</th>
                    <th scope="col">Status</th>
                    <th scope="col">Details</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentData &&
                    paymentData.length > 0 &&
                    paymentData.map((item, index) => (
                      <tr key={index}>
                        <td data-label="Apply date">
                          {item?.applyDate ? item?.applyDate : "N/A"}
                        </td>
                        <td data-label="Receive date">
                          {item?.recievedDate ? item?.recievedDate : "N/A"}
                        </td>
                        <td data-label="Method">{item?.paymentMethod}</td>
                        <td data-label="Amount">৳ {item?.paidAmount || 0}</td>
                        <td data-label="Status">{item?.status}</td>
                        <td data-label="Details">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() =>
                              history.push(`/payments/withdrawal/${item._id}`, {
                                item,
                              })
                            }
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  {/* <tr>
                    <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}
PaymentDashboard.prototype = {
  getCurrentUser: PropTypes.func.isRequired,
}

export default connect(null, { getCurrentUser })(PaymentDashboard)
